import * as React from 'react';
import AdminContainer, {
    AdminPage,
} from '../../containers/admin/common/AdminContainer';
import Page from '../common/Page';

const LoadingProgressConfig: React.FC = () => (
    <Page>
        <AdminContainer page={AdminPage.LoadingProgress} />
    </Page>
);

export default LoadingProgressConfig;
